import { useQuery } from "@apollo/client";
import { GET_ONLY_OFFICE_EDIT_FILE_SETTINGS } from "@/modules/document-register/features/edit-file-with-only-office/api/get-only-office-edit-file-settings";
import { extractFilePropertiesFromOnlyOfficeFileSettings } from "@/modules/document-register/features/edit-file-with-only-office/util/extract-file-properties-from-onlyoffice-file-settings";

export function useOnlyOfficeEditFileSettings({ fileId }: { fileId: string }) {
  const { data, refetch } = useQuery(GET_ONLY_OFFICE_EDIT_FILE_SETTINGS, {
    variables: {
      fileId,
    },
    fetchPolicy: "network-only",
  });

  const settings = data?.getOnlyOfficeEditFileSettings;

  const { extension, filename } =
    extractFilePropertiesFromOnlyOfficeFileSettings(settings);

  return {
    settings,
    extension,
    filename,
    refetch,
  };
}
